export const formatNumberToPrecision = (num: number, precision: number = 2): string => {
  const formattedNumber = num.toFixed(precision);
  return parseFloat(formattedNumber).toString();
};
